// extracted by mini-css-extract-plugin
module.exports = {"responsiveContainer":"_2ohhniZQlDkEtARNAXT9Z8"};